/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDetailRequest } from './ContactDetailRequest';
import {
    ContactDetailRequestFromJSON,
    ContactDetailRequestFromJSONTyped,
    ContactDetailRequestToJSON,
    ContactDetailRequestToJSONTyped,
} from './ContactDetailRequest';

/**
 * 
 * @export
 * @interface UpdateClientPersonalDataRequest
 */
export interface UpdateClientPersonalDataRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    comment: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    formerLastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    country: string;
    /**
     * 
     * @type {Array<ContactDetailRequest>}
     * @memberof UpdateClientPersonalDataRequest
     */
    contactDetails: Array<ContactDetailRequest>;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    insuranceNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClientPersonalDataRequest
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    employmentStatus: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClientPersonalDataRequest
     */
    initialRegistrationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    contactSource: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    qualification: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    placeOfBirth: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    nationality: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    maritalStatus: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    livingSituation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientPersonalDataRequest
     */
    mediaInquiry: string | null;
}

/**
 * Check if a given object implements the UpdateClientPersonalDataRequest interface.
 */
export function instanceOfUpdateClientPersonalDataRequest(value: object): value is UpdateClientPersonalDataRequest {
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('formerLastName' in value) || value['formerLastName'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('contactDetails' in value) || value['contactDetails'] === undefined) return false;
    if (!('insuranceNumber' in value) || value['insuranceNumber'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('employmentStatus' in value) || value['employmentStatus'] === undefined) return false;
    if (!('initialRegistrationDate' in value) || value['initialRegistrationDate'] === undefined) return false;
    if (!('contactSource' in value) || value['contactSource'] === undefined) return false;
    if (!('qualification' in value) || value['qualification'] === undefined) return false;
    if (!('placeOfBirth' in value) || value['placeOfBirth'] === undefined) return false;
    if (!('nationality' in value) || value['nationality'] === undefined) return false;
    if (!('maritalStatus' in value) || value['maritalStatus'] === undefined) return false;
    if (!('livingSituation' in value) || value['livingSituation'] === undefined) return false;
    if (!('mediaInquiry' in value) || value['mediaInquiry'] === undefined) return false;
    return true;
}

export function UpdateClientPersonalDataRequestFromJSON(json: any): UpdateClientPersonalDataRequest {
    return UpdateClientPersonalDataRequestFromJSONTyped(json, false);
}

export function UpdateClientPersonalDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientPersonalDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'],
        'salutation': json['salutation'],
        'title': json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'formerLastName': json['formerLastName'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'contactDetails': ((json['contactDetails'] as Array<any>).map(ContactDetailRequestFromJSON)),
        'insuranceNumber': json['insuranceNumber'],
        'birthday': (json['birthday'] == null ? null : new Date(json['birthday'])),
        'employmentStatus': json['employmentStatus'],
        'initialRegistrationDate': (new Date(json['initialRegistrationDate'])),
        'contactSource': json['contactSource'],
        'qualification': json['qualification'],
        'placeOfBirth': json['placeOfBirth'],
        'nationality': json['nationality'],
        'maritalStatus': json['maritalStatus'],
        'livingSituation': json['livingSituation'],
        'mediaInquiry': json['mediaInquiry'],
    };
}

export function UpdateClientPersonalDataRequestToJSON(json: any): UpdateClientPersonalDataRequest {
    return UpdateClientPersonalDataRequestToJSONTyped(json, false);
}

export function UpdateClientPersonalDataRequestToJSONTyped(value?: UpdateClientPersonalDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
        'salutation': value['salutation'],
        'title': value['title'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'formerLastName': value['formerLastName'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'contactDetails': ((value['contactDetails'] as Array<any>).map(ContactDetailRequestToJSON)),
        'insuranceNumber': value['insuranceNumber'],
        'birthday': value['birthday'] == null ? value['birthday'] : `${value['birthday'].getFullYear()}-${String(value['birthday'].getMonth()+1).padStart(2,'0')}-${String(value['birthday'].getDate()).padStart(2,'0')}`,
        'employmentStatus': value['employmentStatus'],
        'initialRegistrationDate': `${value['initialRegistrationDate'].getFullYear()}-${String(value['initialRegistrationDate'].getMonth()+1).padStart(2,'0')}-${String(value['initialRegistrationDate'].getDate()).padStart(2,'0')}`,
        'contactSource': value['contactSource'],
        'qualification': value['qualification'],
        'placeOfBirth': value['placeOfBirth'],
        'nationality': value['nationality'],
        'maritalStatus': value['maritalStatus'],
        'livingSituation': value['livingSituation'],
        'mediaInquiry': value['mediaInquiry'],
    };
}

